export const publishers = [
    {
      name: "Fantasy Flight Games",
      website: "https://www.fantasyflightgames.com"
    },
    {
      name: "Asmodee",
      website: "https://www.asmodee.com"
    },
    {
      name: "Roxley Games",
      website: "https://www.roxleygames.com"
    },
    {
      name: "Z-Man Games",
      website: "https://www.zmangames.com/"
    },
    {
      name: "Upper Deck",
      website: "https://upperdeckstore.com/games.html"
    },
    {
      name: "Tabletop Tycoon",
      website: "https://www.tabletoptycoon.com/"
    },
    {
      name: "Runaway Parade Games",
      website: "https://www.runawayparade.com/"
    },
    {
      name: "Japanime Games",
      website: "https://japanimegames.com/"
    },
    {
      name: "CMON",
      website: "https://www.cmon.com/"
    },
    {
      name: "Catalyst Game Labs",
      website: "https://store.catalystgamelabs.com/"
    },
    {
      name: "Grandpa Beck's Games",
      website: "https://www.grandpabecksgames.com/"
    },
    {
      name: "Galeforce Nine",
      website: "https://www.gf9games.com/"
    },
    {
      name: "Ares",
      website: "https://www.aresgames.eu/"
    },
    {
      name: "Pendragon Game Studio",
      website: "https://pendragongamestudio.com/"
    },
    {
      name: "Wizards of the Coast: Magic",
      website: "https://magic.wizards.com/en"
    },
    {
      name: "Sorcery: Contested Ream",
      website: "https://sorcerytcg.com/"
    },
    {
      name: "Pokemon",
      website: "https://www.pokemon.com/us"
    },
    {
      name: "Digimon",
      website: "https://en.digimoncard.com/"
    },
    {
      name: "Van Ryder Games",
      website: "https://vanrydergames.com/"
    },
    {
      name: "Heroscape",
      website: "https://www.heroscapers.com/"
    },
    {
      name: "Kingswood Games",
      website: "https://www.warlordsots.com/"
    },
    {
      name: "Community of Amtgarders",
      website: "https://www.amtgard.com/"
    },
    {
      name: "Bandai Namco - Dragon Ball Super",
      website: "https://www.dbs-cardgame.com/"
    },,
    {
      name: "Bandai Namco - One Piece",
      website: "https://en.onepiece-cardgame.com/"
    },
    {
      name: "Avalon Hill",
      website: "https://www.avalonhill.com/en-us"
    },
    {
      name: "Indie Boards & Cards",
      website: "Indie Boards & Cards"
    },
    // Add new publishers here - they'll auto-sort alphabetically
  ];

  
  
  
 
  
    
  
  
  
  

  
  
